import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';

import Footer from '../../Components/Footer/Footer';
import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';
import Select from 'react-select';

import FuelTypeSelect from '../FuelTypes/FuelTypeSelect';
import OilOrder from './OilOrder';
import FuelOrder from './FuelOrder';

const TO_HANGER = 'to hanger';
const TO_RAMP = 'to ramp';
const TO_MAINTENANCE = 'to maintenance';
const OUT_OF_HANGER = 'out of hanger';

const TowOrderTypes = [
  { value: TO_HANGER, label: TO_HANGER },
  { value: TO_RAMP, label: TO_RAMP },
  { value: TO_MAINTENANCE, label: TO_MAINTENANCE },
  { value: OUT_OF_HANGER, label: OUT_OF_HANGER },
];
class CreateOrdersPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fboId: props.fboId,
      id: undefined,
      comments: undefined,
      customerName: undefined,
      tailNumber: undefined,
      location: undefined,
      expectedFulfillDate: undefined,
      fuelTypeId: undefined,
      oilTypeId: undefined,
      towType: undefined,
      oilOrder: {
        oilOrderId: 0,
        orderId: 0,
        oilTypeId: undefined,
        quantity: undefined,
      },
      fuelOrder: undefined,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitOnEnter = this.handleSubmitOnEnter.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleFuelTypeChange = this.handleFuelTypeChange.bind(this);
    this.handleOilTypeChange = this.handleOilTypeChange.bind(this);
    this.selectTowOrderChange = this.selectTowOrderChange.bind(this);
    this.handleOilOrderUpdate = this.handleOilOrderUpdate.bind(this);
    this.handleFuelOrderUpdate = this.handleFuelOrderUpdate.bind(this);
  }

  buildTowOrder() {
    const towOrder = {
      orderId: 0,
      type: this.state.towType,
    };

    return towOrder;
  }

  buildOilOrder() {
    const oilOrder = {
      orderId: 0,
      oilTypeId: this.state.oilTypeId,
      quantity: 28.4,
    };

    return oilOrder;
  }

  buildFuelOrder() {
    const fuelOrder = this.state.fuelOrder;

    // TODO: remove order requests with 'none'

    return fuelOrder;
  }

  buildOrder() {
    const order = {
      id: this.state.id,
      comments: this.state.comments ? this.state.comments.trim() : undefined,
      customerName: this.state.customerName ? this.state.customerName.trim() : undefined,
      tailNumber: this.state.tailNumber ? this.state.tailNumber.trim() : undefined,
      location: this.state.location ? this.state.location.trim() : undefined,
      expectedFulfillDate: this.state.expectedFulfillDate,
    };

    if (this.state.fuelOrder && this.state.fuelOrder.fuelTypeId) {
      order.fuelOrders = [this.buildFuelOrder()];
    }

    if (this.state.towType) {
      order.towOrder = this.buildTowOrder();
    }

    if (this.state.oilOrder && this.state.oilOrder.oilTypeId) {
      order.oilOrder = this.state.oilOrder;
    }

    return order;
  }

  postForm() {
    const endPoint = `v1/fbos/${this.state.fboId}/orders`;

    this.request = Api.get(endPoint, {
      method: 'POST',
      body: JSON.stringify(this.buildOrder()),
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then((response) => {
      if (response.order) {
        this.goBack();
      }
    }).catch((error) => {
      this.refs.notificationSystem.addNotification({
        message: `Unable to create Order ${error.message}`,
        level: 'error',
        position: 'bc',
      });
    });
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  handleSubmit() {
    this.postForm();
  }

  handleOilOrderUpdate(oilOrder) {
    this.setState({ oilOrder });
  }

  handleFuelOrderUpdate(fuelOrder) {
    this.setState({ fuelOrder });
  }

  handleSubmitOnEnter(event) {
    if (event.keyCode === 13) {
      // this.handleSubmit();
    }
  }

  handleFuelTypeChange(value) {
    this.setState({ fuelTypeId: value.value });
  }

  handleOilTypeChange(value) {
    this.setState({ oilTypeId: value });
  }

  selectTowOrderChange(inputValue) {
    const value = inputValue === null ? inputValue : inputValue.value;
    this.setState({ towType: value });
  }


  render() {
    return (
      <div className='app'>
        <NotificationSystem ref="notificationSystem" />
        <main className="page-content">
          <div className="normal-page-header">
            <h1 className="left">Create Order</h1>
            <div className="clear" />
          </div>
          <div className="create-form page-content-items">
            <div class="customerName-wrapper">
              <label>
              Customer Name<br />
                <input
                  id="customerName"
                  type="string"
                  value={this.state.customerName}
                  onChange={e => this.setState({ customerName: e.target.value })}
                  onKeyDown={this.handleSubmitOnEnter} />
              </label>
            </div>
            <div class="tailNumber-and-location-wrapper">
              <label className="tailNumber-wrapper">
              Tail Number<br />
                <input
                  id="tailNumber"
                  type="string"
                  value={this.state.tailNumber}
                  onChange={e => this.setState({ tailNumber: e.target.value })}
                  onKeyDown={this.handleSubmitOnEnter} />
              </label>
              <label className="location-wrapper">
              Plane Location<br />
                <input
                  id="location"
                  type="string"
                  value={this.state.location}
                  onChange={e => this.setState({ location: e.target.value })}
                  onKeyDown={this.handleSubmitOnEnter} />
              </label>
            </div>

            {/* <label>
            TODO: add back in once we allow users to set fulfill dates in the future
            Expected Fulfill Date (hidden)<br />
              <input
                id="expectedFulfillDate"
                type="date"
                value={this.state.expectedFulfillDate}
                onChange={e => this.setState({ expectedFulfillDate: e.target.value })}
                onKeyDown={this.handleSubmitOnEnter} />
            </label> */}
            <FuelOrder
              fboId={this.props.fboId}
              onFormChange={this.handleFuelOrderUpdate} />
            <OilOrder
              fboId={this.props.fboId}
              onFormChange={this.handleOilOrderUpdate}
              oilOrder={this.state.oilOrder} />
            <label>
              Tow Order <br />
              <Select
                id="towType"
                name="fuel-type-select"
                value={this.state.towType}
                options={TowOrderTypes}
                onChange={this.selectTowOrderChange}
                clearable={true}
              />
            </label>
            <label>
            Order Notes<br />
              <textarea
                id="comments"
                rows="5"
                cols="50"
                value={this.state.comments}
                onChange={e => this.setState({ comments: e.target.value })}
                onKeyDown={this.handleSubmitOnEnter} />
            </label>
            <button type="button" onClick={this.handleSubmit} className="btn btn-medium btn-primary">Create</button>
            <button type="button" onClick={this.goBack} className="btn btn-medium btn-alternative-options">Cancel</button>
          </div>
          <Footer />
        </main>
      </div>
    );
  }
}


CreateOrdersPage.propTypes = {
  history: PropTypes.shape({}).isRequired,
  fboId: PropTypes.number.isRequired,
};
export default CreateOrdersPage;




// WEBPACK FOOTER //
// ./src/Containers/Orders/CreateOrderPage.js